export default __webpack_public_path__ + "da14af31fbb1d15a2187dbe48427a237.svg";